<template>
    <div>
        <nav class="navbar is-fixed-top has-shadow" role="navigation" aria-label="main navigation">
            <div class="navbar-brand">
                <router-link class="navbar-item" to="/system">
                    <img v-if="isReferer" src="../assets/sw-logo.png" class="sw-logo" alt="UNET - cars from Japan"/>
                    <img v-else src="../assets/logo.png" alt="UNET - cars from Japan"/>
                </router-link>
                <a role="button"
                   class="navbar-burger"
                   v-bind:class="{ 'is-active': isActive }"
                   @click="isActive = !isActive"
                   aria-label="menu"
                   aria-expanded="false">
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </a>
            </div>

            <div class="navbar-menu" v-bind:class="{ 'is-active': isActive }" @click="checkActive">
                <div class="navbar-start">
                    <div v-if="isAdmin || isSalesStaff || isSupplier" class="navbar-item has-dropdown is-hoverable">
                        <a class="navbar-item">
                        <span class="icon">
                            <i class="fas fa-cogs"></i>
                        </span>
                            <span> Control Panel</span>
                        </a>
                        <div class="navbar-dropdown is-right">
                            <router-link v-if="!isSupplier" to="/plans/" class="navbar-item">
                                Price Plans
                            </router-link>
                            <router-link v-if="!isSalesStaff && !isSupplier" to="/invoices/" class="navbar-item">
                                Invoices
                            </router-link>
                            <router-link v-if="!isSupplier" to="/users/" class="navbar-item">
                                Users
                            </router-link>
                            <router-link v-if="!isSalesStaff && !isSupplier" to="/rates/" class="navbar-item">
                                Exchange Rates
                            </router-link>
                            <router-link v-if="!isSalesStaff && !isSupplier" to="/requests/" class="navbar-item">
                                Requests
                            </router-link>
                            <router-link v-if="!isSupplier" to="/inland/" class="navbar-item">
                                Inland Prices
                            </router-link>
                            <router-link v-if="!isSalesStaff && !isSupplier" to="/companies/" class="navbar-item">
                                Inland Companies
                            </router-link>
                            <router-link v-if="!isSalesStaff && !isSupplier" to="/rec/" class="navbar-item">
                                Rec Fee
                            </router-link>
                            <router-link v-if="!isSalesStaff && !isSupplier" to="/purchases/" class="navbar-item">
                                Purchases
                            </router-link>
                            <router-link v-if="!isSalesStaff" to="/jibaiseki/" class="navbar-item">
                                Jibaiseki
                            </router-link>
                            <router-link v-if="!isSupplier" to="/profit/" class="navbar-item">
                                Profit
                            </router-link>
                        </div>
                    </div>
                    <router-link v-if="!isSupplier && isAffiliate" to="/users/" class="navbar-item">
                        Users
                    </router-link>
                    <router-link v-if="!isSupplier" to="/auctions/advance" class="navbar-item">
                        Auctions
                    </router-link>
                    <router-link v-if="!isSupplier" to="/buy-now" class="navbar-item">
                        Buy Now
                    </router-link>
                    <router-link v-if="!isSupplier && userNotVisitor" to="/bids/" class="navbar-item">
                        Bids
                    </router-link>
                    <router-link v-if="userNotVisitor" to="/cars/" class="navbar-item">
                        Garage
                    </router-link>
                    <router-link v-if="!isSupplier && isAdmin" to="/banking/" class="navbar-item">
                        Banking
                    </router-link>
                    <router-link to="/balance-statement/" class="navbar-item">
                        Balance
                    </router-link>
                    <router-link to="/statement/" class="navbar-item">
                        Statement
                    </router-link>
                    <router-link v-if="!isSupplier" to="/favorites/" class="navbar-item">
                        Favorites
                    </router-link>
                    <router-link v-if="!isSupplier && userNotVisitor && !isSalesStaff" to="/history/" class="navbar-item">
                        History
                    </router-link>
                    <router-link v-if="!isSupplier && userNotVisitor && !isSalesStaff" to="/tools/" class="navbar-item">
                        Tools
                    </router-link>
                </div>


                <div class="navbar-end">
                    <goal v-if="isAdmin"></goal>
                    <deposit v-else></deposit>
                    <div class="navbar-item has-dropdown is-hoverable">
                        <a class="navbar-item">
                            <span>{{ userName }}</span>
                            <span class="icon">
                            <i class="far fa-user-circle"></i>
                        </span>
                        </a>
                        <div class="navbar-dropdown is-right">
                            <a class="navbar-item is-active" @click.prevent="logout">
                                LOGOUT
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </nav>

    </div>
</template>

<script>
    import Deposit from './Navigation/Deposit'
    import Goal from './Navigation/Goal'
    import apiAuth from '../api/apiAuth'
    import PaypalDeposit from "./Navigation/PaypalDeposit";

    export default {
        components: {
            PaypalDeposit,
            Deposit,
            Goal
        },
        data() {
            return {
                isActive: false,
            }
        },
        methods: {
            logout() {
                this.$store.commit('removeToken')
                this.$store.commit('removeRole')

                this.$store.commit('removeUserName')
                this.$store.commit('removeUserCreditAmount')
                this.$store.commit('removeUserManagerGoal')
                if (this.$store.getters.getUserReferer) {
                    this.$store.commit('removeReferer')
                    this.$router.push({path: '/sw-login'})
                } else {
                    this.$store.commit('removeReferer')
                    this.$router.push({path: '/login'})
                }

            },
            checkActive(event) {
                var target = event.target;
                if (target.parentElement.className == 'paypal-img' || event.path.indexOf(document.querySelector('.modal.is-active')) > -1) {

                } else {
                    this.isActive = !this.isActive;
                }
            }
        },
        computed: {
            userNotVisitor() {
                return this.$store.getters.getUserRole !== 'Visitor'
            },
            userName() {
                return this.$store.getters.getUserName + (this.$store.getters.getUserRole == 'Sales Staff' ? ' (' + this.$store.getters.getUserRole + ')' : '')
            },
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isSalesStaff() {
                if (this.$store.getters.getUserRole === 'Sales Staff') {
                    return true
                }
            },
            isSupplier() {
                if (this.$store.getters.getUserRole === 'Supplier') {
                    return true
                }
            },
            isUser() {
                if (this.$store.getters.getUserRole === 'User') {
                    return true
                }
            },
            isAffiliate() {
                if (this.$store.getters.getUserRole === 'Affiliate') {
                    return true
                }
            },
            isReferer() {
                if (this.$store.getters.getUserReferer == 1) {
                    return true
                }
            },
            getPaypalModal(){
                return this.$store.getters.getPaypalModal
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue